export default __webpack_public_path__ + "static/media/ARROW_LEFT.ddc6227b.png";